interface DividerProps {
  isOpen?: boolean;
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({ isOpen = true, className }) => {
  return (
    <div className={`
      h-[1px] 
      transition-all duration-300
      ${isOpen ? 'w-[224px]' : 'w-[40px]'}
      ${className || ''}
    `} />
  );
}; 